if (!customElements.get('related-cart-product')) {
  class RelatedCartProduct extends HTMLElement {
    constructor() {
      super();

      this.hiddenClass = 'hidden';

      this.addToCartForm = this.querySelector('[data-related-add-selected-to-cart]');
      this.optionsList = this.querySelector('[data-related-options-list]');
      this.btnSelect = this.querySelector('[data-related-select-variant]');
      this.btnSelectedVariant = this.querySelector('[data-related-selected-variant-btn]');

      if (this.btnSelect) {
        this.btnSelect.addEventListener('click', this.showOptions.bind(this));
      }

      if (this.btnSelectedVariant) {
        this.btnSelectedVariant.addEventListener('click', this.showOptions.bind(this));
      }

      this.querySelectorAll('[data-related-variant-id]').forEach((option) =>
        option.addEventListener('click', this.selectOption.bind(this))
      );

      this.onBodyClick = this.handleBodyClick.bind(this);
    }

    showOptions(event, show = true) {
      event?.preventDefault();
      event?.stopPropagation();

      if (show) {
        this.optionsList.classList.remove(this.hiddenClass);
        this.optionsList.focus();
        trapFocus(this.optionsList);
        document.body.addEventListener('click', this.onBodyClick);
      } else {
        this.optionsList.classList.add(this.hiddenClass);
        document.body.removeEventListener('click', this.onBodyClick);
        removeTrapFocus();
      }
    }

    selectOption({ currentTarget, target }) {
      const optionTarget = currentTarget || target;
      const variantId = optionTarget?.dataset.relatedVariantId;

      if (!variantId) return;

      const selectedSwatch = optionTarget.querySelector('[data-related-color-swatch]');

      this.querySelector('[data-related-selected-variant-id]').value = variantId;
      this.btnSelect.classList.add(this.hiddenClass);
      this.addToCartForm.classList.remove(this.hiddenClass);

      this.btnSelectedVariant.innerHTML = selectedSwatch.outerHTML;
    }

    handleBodyClick({ currentTarget, target }) {
      const clickTarget = currentTarget || target;
      if (clickTarget !== this.optionsList && !clickTarget.closest('[data-related-options-list]')) {
        this.showOptions(null, false);
      }
    }
  }

  window.ProductForm = RelatedCartProduct;
  customElements.define('related-cart-product', RelatedCartProduct);
}
